module.exports = __webpack_public_path__ + "files/692d385d6fc4cf135295e297b652227a.png";